import { useQuery } from "@tanstack/react-query";
import { Minus } from "lucide-react"; // Lucide icon to replace Bootstrap's dash icon
import { useParams } from "react-router";
import { endpoints } from "../../hooks/endpoints";
import { getToken } from "../../hooks/utils";
import Animation from "../Animation";
import NotFound from "../NotFound";
import Spinner from "../Spinner";
const Invoice = () => {
  const { id } = useParams();

  const fetchInvoice = async () => {
    const response = await fetch(`${endpoints.invoice}?invoice=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      method: "GET",
    });
    if (!response.ok) throw new Error('حدث خطأ');
    const res = await response.json();
    return res;
  };

  const {
    data: invoice,
    isPending,
    error,
  } = useQuery({
    queryKey: ["invoice", id],
    queryFn: fetchInvoice,
    staleTime: 5 * 60 * 1000,
  });

  if (error) return <NotFound />;

  if (isPending)
    return (
      <div className="grow flex justify-center items-center">
        <Spinner />
      </div>
    );

  return (
    <Animation>
      <div className="w-full max-w-5xl mx-auto px-4 py-6 mt-6">
        <h2 className="px-4 py-3 mb-4 bg-primary text-white rounded-lg text-xl font-semibold">
          عملية شراء رقم ({id})
        </h2>

        <div className="bg-white rounded-lg shadow p-4 overflow-x-auto">
          {invoice && (
            <>
              <div className="w-full mb-4 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800">
                <span className="font-semibold">التاريخ :</span> ({" "}
                {invoice.date} ) -{" "}
                <span className="font-semibold">الحالة :</span> (
                {invoice.status === "completed" ? (
                  <span className="inline-block ml-1 font-semibold text-green-600">
                    تم الدفع
                  </span>
                ) : invoice.status === "pending" ? (
                  <span className="inline-block ml-1 font-semibold text-red-600">
                    منتظر الدفع
                  </span>
                ) : (
                  invoice.status
                )}
                )
              </div>

              <table className="min-w-full border border-gray-200 text-right">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 border-b border-gray-200 text-sm font-medium text-gray-700">
                      {invoice.is_wallet_or_codes ? "المنتج" : "الحصة"}
                    </th>
                    <th className="px-4 py-2 border-b border-gray-200 text-sm font-medium text-gray-700">
                      القيمة
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="px-4 py-2 text-sm text-gray-800">
                      {invoice.count > 1
                        ? `x ${invoice.count} ${invoice.lesson}`
                        : invoice.lesson}
                    </td>
                    <td className="px-4 py-2 text-sm text-gray-800">
                      {invoice.subtotal} جنيه
                    </td>
                  </tr>

                  {!invoice.is_wallet_or_codes && (
                    <tr className="border-b border-gray-200">
                      <td className="px-4 py-2 text-sm text-gray-800">
                        شراء بالكود
                      </td>
                      <td className="px-4 py-2 text-sm text-gray-800">
                        {invoice.code ? (
                          invoice.code
                        ) : (
                          <Minus className="w-4 h-4 text-gray-400 inline" />
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </Animation>
  );
};

export default Invoice;
